import { ApiError } from 'app/typings/error';
import type { PublishError } from 'app/typings/publishError';

export function isPublishError(err: unknown): err is PublishError {
  return (
    err instanceof Error &&
    typeof err.cause === 'object' &&
    err.cause !== null &&
    'data' in err.cause &&
    typeof (err.cause as { data?: unknown }).data === 'object' &&
    (err.cause as { data?: unknown }).data !== null &&
    'missingFields' in (err.cause as { data: object }).data
  );
}

export function extractMissingFields(err: unknown): string[] | null {
  if (err instanceof ApiError) {
    const data = (err.jsonObject as { data?: { missingFields?: string[] } })
      ?.data;

    if (data && Array.isArray(data.missingFields)) {
      return data.missingFields;
    }
  }

  if (isPublishError(err)) {
    return err.cause.data?.missingFields ?? null;
  }

  return null;
}
